import React, { useId } from 'react';
import type { RadioButtonProps } from './radio-button.types';
import styles from './radio-button.module.css';
import { cn } from '../../../lib/utils';
import Text from '../../atoms/text';

export const RadioButton: React.FC<RadioButtonProps> = ({
    showIf = true,
    className,
    checkMarkClassName,
    labelClassName,
    label,
    labelProps,
    checked,
    disabled = false,
    allowUncheck = false,
    onChange,
    size = 'medium',
    id: providedId,
    ...props
}) => {
    const generatedId = useId();
    if (!showIf) return null;

    const id = providedId || generatedId;

    const handleClick = () => {
        if (!disabled && onChange) {
            onChange();
        }
    };

    return (
        <div
            className={cn(
                styles.rootClassName,
                styles[`size-${size}`],
                disabled && styles.disabled,
                checked && styles.checked,
                allowUncheck && styles.allowUncheck,
                className
            )}
        >
            <div className={styles.radioContent}>
                <button
                    type="button"
                    id={id}
                    aria-checked={checked}
                    role="radio"
                    disabled={disabled}
                    onClick={handleClick}
                    className={cn(styles.radioButtonContainer, labelClassName)}
                    {...props}
                >
                    <span className={cn(styles.checkmark, checkMarkClassName)} />
                </button>
            </div>

            <Text
                showIf={!!label}
                size="small"
                className={cn(styles.description, labelProps?.className)}
                {...labelProps}
            >
                {label}
            </Text>
        </div>
    );
};
